import { Box, IconButton } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { FC, useState } from "react";

import { RequestStatus } from "../types";
import useOnUpdateRecord from "../../../hooks/useOnUpdateRecord";
import TooltipPopover from "../../../components/TooltipPopover";
import { AppResource } from "../../../types/resource.types";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { requestDocRef } from "../../../utils/referencies";
import colors from "../../../theme/colors";
import Loader from "../../../components/Loader";

const ApproveRequest: FC<any> = ({ record }) => {
  const request = record;
  const status: RequestStatus = request.status;

  const [loading, setLoading] = useState(false);

  const onUpdateRecord = useOnUpdateRecord(
    AppResource.visitsRequests,
    "Request has been approved",
    "Error on approve request"
  );

  const handleApproveRecord = async (e: any) => {
    setLoading(true);
    e.stopPropagation();
    await onUpdateRecord(async () => {
      await requestDocRef(request.id).update(
        applyUpdateTimestamp({
          status: RequestStatus.confirmed,
        })
      );
      setLoading(false);
    });
  };

  const ActionIcon: FC = () => (
    <Loader loading={loading} size={18}>
      <TooltipPopover message={"Approve request"}>
        <IconButton onClick={handleApproveRecord}>
          <CheckCircleOutlineIcon style={{ color: colors.success.main }} />
        </IconButton>
      </TooltipPopover>
    </Loader>
  );

  return <>{status === RequestStatus.pending ? <Box onClick={handleApproveRecord}>{ActionIcon}</Box> : null}</>;
};

export default ApproveRequest;
